<template>
  <div class="box">
    <div
      class="top"
      style="
        background: url(../static/images/cs/e2809b0597463b3c879c0f44dded9a81.jpg);
        background-position-x: center;
        background-position-y: center;
        background-repeat: no-repeat;
      "
    ></div>
    <div class="center">
      <div class="text">
        <p class="title">公司简介</p>
      </div>
      <div class="aboutus">
        <div class="content">
          <p>
            行运易一直致力于为客户提供可靠的、稳定、多元且高效的跨境物流解决方案，未来我们也将秉持这一理念，以客为本，服务领先，不断开拓跨境物流新模式，深挖客户服务体验要点，展现我们作为一流的跨境物流服务提供者的优势与坚持。
            行运易愿与您携手，共建跨境电商新业态，誓出之日，名利与共。
          </p>
        </div>
          <img src="@/images/Air-Freight.png" />
      </div>
    </div>
  </div>
</template>
<style scoped>
.top {
  width: 100%;
  height: 200px;
}

.center {
  width: 1300px;
  box-sizing: border-box;
  padding: 50px 50px 100px 50px;
  min-height: 800px;
  background-color: #ffffff;
  border-radius: 5px;
  margin: 0 auto;
  margin-top: -40px;
  color: #4b4b4b;
}

.text p {
  padding: 30px 0;
  padding-top: 0;
  border-bottom: 1px solid #939393;
  margin: 0;
}

.text .title {
  font-weight: 800;
  font-size: 36px;
}

.aboutus {
  margin-top: 20px;
  display: flex;

}

.aboutus .content {
  padding-right: 20px;
  font-size: 20px;
  line-height: 46px;
  text-indent: 2em;
}

.aboutus img {
  width: 40%;
}
</style>
<script>
export default {
  data () {
    return {
      dto: {}
    }
  },
  name: 'AboutUS'
}
</script>



// WEBPACK FOOTER //
// src/components/aboutus.vue